import { render } from "./ModelVersionTable.vue?vue&type=template&id=0373f469&scoped=true"
import script from "./ModelVersionTable.vue?vue&type=script&lang=js"
export * from "./ModelVersionTable.vue?vue&type=script&lang=js"

import "./ModelVersionTable.vue?vue&type=style&index=0&id=0373f469&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0373f469"]])

export default __exports__